module.exports = __webpack_public_path__ + "img/renovacion-popular.d0af529d.png";